
document.addEventListener('DOMContentLoaded', init, false);

function init() {
    if ('serviceWorker' in navigator && navigator.onLine) {
        navigator.serviceWorker.register("//fastprint.co.id/cdn/shop/t/3/assets/service-worker.js?v=22244176506232202951781944571")
        .then((reg) => {
            console.log('Registrasi service worker Berhasil', reg);
        }, (err) => {
            console.log('Registrasi service worker Gagal', err);
        });
    }
}